import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectBasketcustomerGroupDetail: "selectBasketcustomerGroupDetail [Action]",
  selectBasketcustomerGroupDetailLoading:
    "selectBasketcustomerGroupDetailLoading [Action]",
  selectBasketcustomerGroupDetailAsync:
    "selectBasketcustomerGroupDetailAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_basketcustomer_group_detail_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectBasketcustomerGroupDetail:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectBasketcustomerGroupDetailLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectBasketcustomerGroupDetailLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_basketcustomer_group_detail",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectBasketcustomerGroupDetail,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectBasketcustomerGroupDetailLoading,
      payload: false,
    });
  }
}

export function* selectBasketcustomerGroupDetail() {
  yield takeLatest(
    actionTypes.selectBasketcustomerGroupDetailAsync,
    handleWorker
  );
}
